import { MobileApplicationAppConfig } from '../../types';

export const mobileApplicationAppConfig: MobileApplicationAppConfig = {
  androidApkUrl: 'https://storage.googleapis.com/static-content-lvbetcom-new/bcf-twa/lvbetlv/lvbetlv-casino.apk',
  iosStoreUrl: 'https://apps.apple.com/lv/app/lv-kazino/id6448981183'
};
